/* 布局 */
//前台
import Layout from "@views/layout";

const topicRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "topic",
            name: "TOPIC",
            meta: {
                title: "话题管理",
                sort: 1,
            },
            component: () => import("@views/business/topic/index.vue"),
            redirect: {
                name: "TOPIC_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "TOPIC_LIST",
                    meta: {
                        title: "话题管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/topic/list.vue"),
                },
                                {
                    path: "add",
                    name: "TOPIC_ADD",
                    meta: {
                        title: "新增话题表",
                        parentPath: '/business/topic/list',
                        operate: true,
                    },
                    component: () => import("@views/business/topic/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "TOPIC_EDIT",
                    meta: {
                        title: "编辑话题表",
                        parentPath: '/business/topic/list',
                        operate: true,
                    },
                    component: () => import("@views/business/topic/form.vue"),
                },
                                        ],
    },


        ],
};

export default topicRouter;
